import {
  aggregationSUM,
  aggregationAmount,
  aggregationAmountCustom,
  getOptions,
  initCalculation,
  sortRecords
} from '@/utils/index'

const canEdit = {
  canEdit: true,
  canModify: true
}
const canModify = {
  canModify: true
}

const topColumns = [
  {
    field: 'costName',
    title: '费用名称',
    ...canEdit,
    aggregation: aggregationSUM
  },
  { field: 'unit', title: '单位', ...canEdit },
  { field: 'quantity', title: '数量', fieldType: 'number', ...canEdit },
  { field: 'rate', title: '单价', fieldType: 'number', ...canEdit },
  {
    field: 'baseAmount',
    title: '取费基数',
    ...canModify
  },
  {
    field: 'costRatio',
    title: '费率',
    fieldType: 'number',
    ...canEdit,
    scale: 5
  },
  {
    field: 'estimateAmount',
    title: '估算金额',
    aggregation: aggregationAmount
  },
  {
    field: 'estimateAmountTotal',
    title: '总估算金额',
    aggregation: aggregationAmount
  },
  {
    field: 'calculationRule',
    title: '计算规则',
    ...canEdit,
    ...getOptions({
      title: '计算规则',
      key: 'calculationRule',
      options: [{ name: '量价' }, { name: '取费' }]
    })
  },
  {
    field: 'costType',
    title: '成本类型',
    ...canEdit,
    ...getOptions({
      title: '成本类型',
      key: 'costType',
      options: [{ name: '总价' }, { name: '月度' }]
    })
  },
  {
    field: 'planStartDate',
    title: '计划开始时间',
    editor: { type: 'date' },
    ...canEdit
  },
  {
    field: 'planEndDate',
    title: '计划结束时间',
    editor: { type: 'date' },
    ...canEdit
  }
]

const bottomColumns = [
  { field: 'name', title: '历史工程名称', aggregation: aggregationSUM },
  { field: 'engineeringClassifyName', title: '工程分类' },
  { field: 'regionName', title: '所在地区' },
  // { field: 'measurementUnit', title: '计量单位' },
  {
    field: 'constructionScale',
    title: '建设规模'
  },
  {
    field: 'costBudget',
    title: '总造价',
    fieldType: 'number',
    aggregation: aggregationAmount
  },
  {
    field: 'costBudgetIndicator',
    title: '造价指标',
    fieldType: 'number',
    aggregation: aggregationAmount
  },
  {
    field: 'adjustPriceCoefficient',
    title: '调价系数',
    fieldType: 'number',
    ...canEdit
  },
  {
    field: 'costBudgetIndicatorActual',
    title: '调整后的造价指标',
    aggregation: aggregationAmount,
    calculation: initCalculation(
      ['costBudgetIndicator', 'adjustPriceCoefficient'],
      'costBudgetIndicator * adjustPriceCoefficient'
    )
  }
]

const leftColumns = [
  { field: 'planDate', title: '年月' },
  { field: 'estimateCost', title: '月度估算成本' },
  { field: 'estimateIncome', title: '月度估算收入' },
  { field: 'inflow', title: '净流入' },
  { field: 'inflowTotal', title: '累计净流入' }
]

const rightColumns = [
  { field: 'name', title: '附件名称', cellType: 'link' },
  { field: 'unit', title: '锁号' },
  { field: 'quantity', title: '联系人' },
  { field: 'sysCreatedDate', title: '编制日期' }
]

const topColumns1 = [
  { field: 'name', title: '单项工程', ...canEdit, aggregation: aggregationSUM },
  { field: 'measurementUnit', title: '计量单位', ...canEdit },
  {
    field: 'constructionScale',
    title: '建设规模',
    ...canEdit,
    aggregation: aggregationAmountCustom(record => {
      return !!record.summaryFlag
    })
  },
  {
    field: 'summaryFlag',
    title: '汇总标记',
    multiple: true,
    cellType: 'checkbox',
    ...canEdit
  },
  {
    field: 'engineeringClassifyName',
    title: '工程分类',
    ...canModify,
    editModal: {
      columns: [{ field: 'name', title: '工程分类', tree: true }],
      async options() {
        const res = await this.$service.get(
          '/engineering-classify/listAllClassify',
          {}
        )
        return sortRecords(res?.data || [])
      },
      confirm(selectedCellInfos, res) {
        const row = res[0][0].originData
        selectedCellInfos.forEach(cells => {
          const obj = cells[0].originData
          this.$set(obj, 'engineeringClassifyName', row.name)
          this.$set(obj, 'engineeringClassifyId', row.id)
        })
      }
    }
  },
  {
    field: 'regionName',
    title: '所在地区',
    editModal: {
      columns: [{ field: 'name', title: '所在地区' }],
      async options() {
        const res = await this.$service.get('/region/list', {})
        return sortRecords(res?.data || [])
      },
      confirm(selectedCellInfos, res) {
        const row = res[0][0].originData
        selectedCellInfos.forEach(cells => {
          const obj = cells[0].originData
          this.$set(obj, 'regionName', row.name)
          this.$set(obj, 'regionId', row.id)
        })
      }
    },
    canModify: true
  },
  { field: 'address', title: '详细地址', ...canEdit },
  {
    field: 'planStartDate',
    title: '计划开始时间',
    editor: { type: 'date' },
    ...canEdit
  },
  {
    field: 'planEndDate',
    title: '计划结束时间',
    editor: { type: 'date' },
    ...canEdit
  },
  {
    field: 'estimateAmount',
    title: '估算金额',
    ...canEdit,
    fieldType: 'number',
    aggregation: aggregationAmount
  },
  {
    field: 'costIndicator',
    title: '造价指标',
    ...canEdit,
    fieldType: 'number',
    aggregation: aggregationAmount
  }
]

const topColumns2 = [
  { field: 'costName', title: '名称', tree: true },
  { field: 'percentage', title: '占比(%)' },
  { field: 'estimateCost', title: '估算成本(万元)' },
  { field: 'estimateIncome', title: '估算收入(万元)' },
  { field: 'inflow', title: '净流入(万元)' },
  { field: 'planStartDate', title: '计划开始年月' },
  { field: 'planEndDate', title: '计划结束年月' }
]

const topColumns3 = topColumns.map(e => ({
  ...e,
  title:
    e.title === '成本类型'
      ? '收入类型'
      : e.title === '费用名称'
        ? '收入名称'
        : e.title
}))

const topColumns4 = [...topColumns]
topColumns4.splice(6, 0, {
  field: 'interest',
  title: '利息',
  fieldType: 'number',
  ...canEdit
})
topColumns4.splice(11, 0, {
  field: 'costRateRule',
  title: '利息规则',
  ...canEdit,
  ...getOptions({
    title: '利息规则',
    key: 'costRateRule',
    options: [{ name: '单利' }, { name: '复利' }]
  })
})

const tabs = [
  {
    label: '土地成本',
    value: 'common-land-cost',
    columns: {
      top: topColumns,
      bottom: [],
      left: leftColumns,
      right: rightColumns
    }
  },
  {
    label: '建安成本',
    value: 'pie-project-unit-cost',
    columns: {
      top: topColumns1,
      bottom: bottomColumns,
      left: leftColumns,
      right: rightColumns
    }
  },
  {
    label: '取费项目',
    value: 'common-charging-items',
    columns: {
      top: topColumns,
      bottom: [],
      left: leftColumns,
      right: rightColumns
    }
  },
  {
    label: '销售成本',
    value: 'common-sale-cost',
    columns: {
      top: topColumns,
      bottom: [],
      left: leftColumns,
      right: rightColumns
    }
  },
  {
    label: '运维成本',
    value: 'common-ops-cost',
    columns: {
      top: topColumns,
      bottom: [],
      left: leftColumns,
      right: rightColumns
    }
  },
  {
    label: '销售收入',
    value: 'common-sale-income',
    columns: {
      top: topColumns3,
      bottom: [],
      left: leftColumns,
      right: rightColumns
    }
  },
  {
    label: '运营收入',
    value: 'common-ops-income',
    columns: {
      top: topColumns3,
      bottom: [],
      left: leftColumns,
      right: rightColumns
    }
  },
  {
    label: '现金流量',
    value: 'common-cash-flow',
    columns: {
      top: topColumns2,
      bottom: [],
      left: leftColumns,
      right: rightColumns
    }
  },
  {
    label: '财务成本',
    value: 'common-finance-cost',
    columns: {
      top: topColumns4,
      bottom: [],
      left: leftColumns,
      right: rightColumns
    }
  },
  {
    label: '投资估算',
    value: 'common-investment-estimate',
    columns: {
      top: topColumns2,
      bottom: [],
      left: leftColumns,
      right: rightColumns
    }
  }
]

export { tabs }
